import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as R from 'ramda';

import { SubcategoryGames as SubcategoryGamesCore } from 'core/components';
import { withCoreComponent } from 'core/hocs';
import { sortGamesByNullableProp } from 'core/helpers';
import { GAMES_SUBCATEGORY } from 'core/constants';

import { GameSectionHeader } from 'components/game-section-header/game-section-header';
import { GamesCarousel } from 'components/games-carousel/games-carousel';

import './subcategory-games.scss';

export const SubcategoryGamesCarouselUI = ({
  games,
  isUserLoggedIn,
  className,
  subcategory,
}) => !R.isEmpty(games) && (
  <div className={classNames('subcategory-games-carousel px-2 px-sm-2_5 px-lg-4_75', className)}>
    <GameSectionHeader
      route={subcategory === GAMES_SUBCATEGORY.LIVE_CASINO ? '/games/live' : `/subcategory/${subcategory}`}
      headerKey={`games.subcategory.${subcategory}`}
    />

    <GamesCarousel
      isUserLoggedIn={isUserLoggedIn}
      games={sortGamesByNullableProp('sortIndex')(games)}
      rows={2}
    />
  </div>
);

SubcategoryGamesCarouselUI.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  games: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
  subcategory: PropTypes.string.isRequired,
};

SubcategoryGamesCarouselUI.defaultProps = {
  games: [],
  className: null,
};

export const SubcategoryGamesCarousel = withCoreComponent(SubcategoryGamesCore, SubcategoryGamesCarouselUI);
